import * as React from 'react';
import { Routes, Navigate, Route } from 'react-router-dom';
import { ProtectedLayout } from './components/auth/Protected';
import { AuthLayout } from './components/auth/AuthLayout';
import Dashboard from './Dashboard';
import JobSearch from './JobSearch';
import UserSearch from './UserSearch';
import EmployerSearch from './EmployerSearch';
import CompanySearch from './CompanySearch';
import Job from './Job';
// import User from './User';
import UserView from './components/CandidateSingle/UserView';
import Profile from './Profile';
import Project from './Project';
import Employer from './Employer';
import Projects from './ProjectSearch';
import Planner from './Planner';
import Logout from './Logout';
import EmployerRegistration from './EmployerRegistration';
import ManageJob from './ManageJob';
import JobSeekerRegistration from './components/jobSeeker/Registration';
import Login from './Login';
import Resume from './Resume';
import TermsOfUse from './components/staticPages/TermsOfUse';
import Privacy from './components/staticPages/Privacy';
import Onboarding from './components/jobSeeker/onboarding';

export default function App() {
  return (
    <Routes>
      <Route element={<AuthLayout />}>
        <Route path="/" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/my" element={<ProtectedLayout />}>
          <Route path="profile" element={<Profile />} />
        </Route>
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<ProtectedLayout />}>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="jobs" element={<JobSearch />} />
          <Route path="job-posting" element={<ManageJob />} />
          <Route path="job-posting/:slug" element={<ManageJob />} />
          <Route path="job/:slug" element={<Job />} />
          <Route path="users" element={<UserSearch />} />
          <Route path="user/:id" element={<UserView />} />
          <Route path="projects" element={<Projects />} />
          <Route path="project/:id" element={<Project />} />
          <Route path="employers" element={<EmployerSearch />} />
          <Route path="companies" element={<CompanySearch />} />
          <Route path="employer/:id" element={<Employer />} />
          <Route path="planner" element={<Planner />} />
        </Route>
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/privacy-policy" element={<Privacy />} />
      </Route>
      <Route
        path="/job-seeker/registration"
        element={<JobSeekerRegistration />}
      />
      <Route path="/employer/registration" element={<EmployerRegistration />} />
      <Route path="/job-seeker/onboarding" element={<Onboarding />} />
    </Routes>
  );
}
